export default __webpack_public_path__ + "static/media/circle_plane.3dffbb4b.svg";